import { createContext, use } from 'react';

import { GProduct, Variant } from '@/types';

interface ISelectOption<T> {
  label: string;
  value: T;
}

export interface UnitPricingTier {
  qty: number;
  price: number;
}

export interface CompoundType {
  type: Compound;
  value: string | null;
}

export type Compound = 'THC' | 'CBD' | 'TAC';

interface ProductState {
  product: GProduct;
  isSpecial: boolean;
  quantity: number;
  weightVariant: Variant;
  variants: Variant[];
  unitPricingTiers?: UnitPricingTier[];
  unitPricingTier?: UnitPricingTier;
  updateWeightVariant: (_option: ISelectOption<string>) => void;
  updateUnitPricingTier: (_option: UnitPricingTier) => void;
  compoundList: CompoundType[];
}

const ProductContext = createContext<undefined | ProductState>(undefined);
ProductContext.displayName = 'ProductContext';

const useProductContext = () => {
  const context = use(ProductContext);

  if (!context) {
    throw new Error('useProductContext must be used within a ProductProvider');
  }

  return context;
};

export { ProductContext, useProductContext };
